import { Temporal } from 'temporal-polyfill'
import { base } from '@workday/canvas-tokens-web'
import { BoxProps, Box } from '~/design_system'

/**
 * Returns the part of the day based on the current time.
 * 5am to 12pm -> 'morning'
 * 12pm to 5pm -> 'afternoon'
 * 5pm to 5am -> 'evening'
 */
export function getPartOfDay(): 'morning' | 'afternoon' | 'evening' {
  const nowTime = Temporal.Now.plainTimeISO()
  let part: 'morning' | 'afternoon' | 'evening' = 'afternoon'
  if (nowTime.hour < 5 || nowTime.hour >= 17) {
    part = 'evening'
  } else if (nowTime.hour < 12) {
    part = 'morning'
  }
  return part
}

const fadeIn = 'linear-gradient(to bottom, rgba(245 245 245 / 0%) 10%, var(--vndly-color-app-background) 100%)'
const morning = `${fadeIn}, linear-gradient(262deg, #FC8A2D -10.24%, #FDC5A0 11.81%, #FAD2D6 22.83%, #E6D0F5 33.86%, #B9C3F8 44.88%, #2990DD 72.44%, #0867BB 94.49%)`
const afternoon = `${fadeIn}, linear-gradient(262deg, #FF8315 -10.24%, #FECB68 11.81%, #FDE695 22.83%, #EEEEB7 33.86%, #CAE5CE 44.88%, #96D6D6 55.9%, #1B71B8 94.49%)`
const evening = `${fadeIn}, linear-gradient(262deg, #FFBE61 -10.24%, #FFDBBA 11.81%, #EEC9DB 22.83%, #C8A2E1 33.86%, #8579CF 44.88%, #2559AF 61.42%, #052E5C 94.49%)`

const background = {
  morning,
  afternoon,
  evening
}[getPartOfDay()]

export const iconColor = {
  morning: `var(${base.azure500})`,
  afternoon: `var(${base.azure500})`,
  evening: `var(${base.blue700})`
}[getPartOfDay()]

export const BannerGraphic = ({ children, ...props }: BoxProps) => {
  return (
    <Box pos="relative" bgSize="cover" {...props}>
      <Box
        sx={{
          position: 'absolute',
          w: 'full',
          h: 'full',
          maxH: { base: '550px', md: 'full' },
          background,
          // This mask gradient in addition to the fadeIn gradient in the background gives a smoother overall look
          maskImage: 'linear-gradient(rgba(0 0 0 / 100%) 30%, rgba(0 0 0 / 40%) 90%)'
        }}
      />
      <Box pos="relative" pb={children ? '58px' : '200px'} mb={children ? '-33px' : '-200px'} pt={children ? 6 : 0}>
        {children}
      </Box>
    </Box>
  )
}
